import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const AutoShareDiscoveryModal = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./auto_share_discovery_modal.js')).AutoShareDiscoveryModal })
  )
)
